// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  hmr: false,
  tokenKey: "a6smm_utoken",
  wssocket_url: 'wss://staging-websocket.hansel.io',
  // wssocket_url: 'wss://websocket-visualizer.hansel.io',
  returnURL: 'https://diltest.hansel.io/redirecting-to-netcore-ce',
  setToken: function (token) {
    localStorage.setItem(this.tokenKey, JSON.stringify(token));
  },
  isAuthenticated: function () {
    let isTokenAvailable = localStorage.getItem(this.tokenKey) ? true : false;
    return isTokenAvailable;
  },
  refreshToken() {
    this.token.exp = new Date(new Date().getDate() + 1);
    this.setToken(this.token);
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
